import { render, staticRenderFns } from "./EngravingUpsellList.vue?vue&type=template&id=1a96ae76&scoped=true&"
import script from "./EngravingUpsellList.vue?vue&type=script&lang=js&"
export * from "./EngravingUpsellList.vue?vue&type=script&lang=js&"
import style0 from "./EngravingUpsellList.vue?vue&type=style&index=0&id=1a96ae76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96ae76",
  null
  
)

export default component.exports